
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Proper lazy loading with fallback components
const Home = lazy(() => import('../pages/home/page'));
const Login = lazy(() => import('../pages/login/page'));
const Patients = lazy(() => import('../pages/patients/page'));
const Prescriptions = lazy(() => import('../pages/prescriptions/page'));
const Users = lazy(() => import('../pages/users/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/patients',
    element: <Patients />
  },
  {
    path: '/prescriptions',
    element: <Prescriptions />
  },
  {
    path: '/users',
    element: <Users />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
